// @ts-nocheck
import { BASE_URL, CLIENT_ID, REDIRECT_URL, RESOURCE_ID } from '../../../config';
import { httpClient } from '../../../core/network';

const RESPONSE_TYPE = 'code id_token';
const SCOPE = 'openid offline_access';

class AuthService {
  static guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  }

  static fetchCode() {
    const guid = AuthService.guid();
    window.location.href = `${BASE_URL}/authorize?client_id=${CLIENT_ID}&resource=${RESOURCE_ID}&redirect_uri=${REDIRECT_URL}&response_type=${RESPONSE_TYPE}&scope=${SCOPE}&nonce=${guid}`;
  }

  static fetchToken(code) {
    const apiUrl = `/oauth2/token?code=${code}`;
    return httpClient.get(apiUrl, {
      headers: { Accept: 'application/json' },
    });
  }

  static fetchCurrentUser() {
    const apiUrl = '/authentication';
    return httpClient.get(apiUrl);
  }
}

export default AuthService;
